import { useState } from "react";
import {
  CreditsCard,
  CreditUsageChart,
  BillingHistoryTable,
  UsageBreakdownTable,
  BuyAdditionalCreditModal,
} from "./components";
import { useCredits } from "hooks/useCredits";

type TabType = "billing-history" | "usage-breakdown";

const TABS: { key: TabType; label: string }[] = [
  { key: "billing-history", label: "Billing History" },
  { key: "usage-breakdown", label: "Usage Breakdown" },
];

const CreditsBilling = () => {
  const [activeTab, setActiveTab] = useState<TabType>("billing-history");
  const [showTopupModal, setShowTopupModal] = useState(false);

  const { credits, isLoading, refetch } = useCredits();

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8 h-[calc(100vh-76px-var(--credit-banner-h,0px))] overflow-auto">
      <BuyAdditionalCreditModal
        isOpen={showTopupModal}
        onClose={() => setShowTopupModal(false)}
        currentBalance={credits?.totalAvailable ?? 0}
        onPaymentSuccess={() => {
          refetch();
          setShowTopupModal(false);
        }}
      />

      {/* Credits summary + usage chart */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <CreditsCard
          credits={credits}
          isLoading={isLoading}
          onTopupCredit={() => setShowTopupModal(true)}
        />
        <CreditUsageChart />
      </div>

      {/* Billing history / usage breakdown */}
      <div className="bg-white rounded-2xl p-6 shadow-sm">
        <div className="flex mb-6">
          <div className="inline-flex bg-gray-100 rounded-full p-2">
            {TABS.map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all ${
                  activeTab === key ? "bg-[#012169] text-white" : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {activeTab === "billing-history" ? <BillingHistoryTable /> : <UsageBreakdownTable />}
      </div>
    </div>
  );
};

export { CreditsBilling };
